/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicResourceDiscovery extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicResourceDiscovery");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicResourceDiscovery.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicResourceDiscovery>): BackgroundJobPayloadForPeriodicResourceDiscovery {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicResourceDiscovery(), model);
        BackgroundJobPayloadForPeriodicResourceDiscovery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicResourceDiscovery>): BackgroundJobPayloadForPeriodicResourceDiscovery {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicResourceDiscovery.newInstance(<BackgroundJobPayloadForPeriodicResourceDiscovery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicResourceDiscovery) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicResourceDiscovery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicResourceDiscovery): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicResourceDiscovery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
